import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.allClasses)
  }, [
    _createElementVNode("p", {
      class: _normalizeClass({ 'u-mar-y-0': !_ctx.vertikalZentrieren })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.zeigeInfo && _ctx.infoBoxId)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "c-notice-icon",
            title: "Hilfe anzeigen",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.infoClick && _ctx.infoClick(...args))),
            "aria-hidden": "true"
          }, [
            _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}